import { FaPeopleArrows } from "react-icons/fa";
import { GrPlan } from "react-icons/gr";
import { RxLapTimer } from "react-icons/rx";
// import { MdWorkspacePremium } from "react-icons/md";
import { FaHandsHelping } from "react-icons/fa";

export const workProcess = [
  {
    id: "01",
    icon: FaPeopleArrows,
    name: "Consultation",
    desc: "We start by understanding your requirements, inspecting the site if necessary, and discussing the scope of the project to create a tailored solution"
  },
  {
    id: "02",
    icon: GrPlan ,
    name: "Planning & Quotation",
    desc: "Our team prepares a detailed plan and provides a competitive quote, ensuring complete transparency in costs and timelines."
  },
  {
    id: "03",
    icon: RxLapTimer,
    name: "Execution",
    desc: "Our skilled technicians execute the project with precision, using high-quality materials and advanced techniques to achieve the desired results"
  },
  // {
  //   id: "04",
  //   icon: MdWorkspacePremium,
  //   name: "Quality Assurance",
  //   desc: "We conduct a thorough inspection to ensure the work meets our strict quality standards and your expectations."
  // },
  {
    id: "05",
    icon: FaHandsHelping,
    name: "Handover & Support",
    desc: "After completing the project, we provide a detailed walkthrough and offer ongoing maintenance support if required."
  }
];
